import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events/api/events-api.service';

const { getParticipantsRequest } = EventsApiService();

const getParticipantsRequestQuery = (
    id: any,
    flag:any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: ['getParticipantsRequest', id],
    queryFn: ({ signal }) => getParticipantsRequest(id,flag, { config: { signal } }),
    ...options,
});

export const useGetParticipantsRequest = (
    id: any,
    flag:any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getParticipantsRequestQuery(id,flag, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);
                message.error(uiMessage);
            },
            onSuccess: (data) => {
                const res = data.ResponseStatus
                if (res === 1) {
                    message.success(data.ResponseMessage);
                } else {
                    message.error(data.ResponseMessage || "failed");
                }
            },

            ...options,
        }),
    );
};
